// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a6465dd4","977":"d5d477b0"}[chunkId] + ".chunk.js";
};